export default __webpack_public_path__ + "static/media/dandyAce.96d8799d.png";